import { modifyCronData, reverseModifyCronData } from "views/RunBook/utils/cronUtil";
import APIClient, { failSafe, makeCancellableAPIRequest } from "./index";
import Sorters from "utils/sorters";

const SavedSearchAPI = {
    shareFilterLink(data) {
        return failSafe(APIClient.post('/api/savedSearch/share', data));
    },
    getAllSavedFilter(filterType, params, skipSort) {
        const promiseObject = makeCancellableAPIRequest(
            "GET",
            `/api/savedSearch/${filterType}`,
            { params }
        );
        if(!skipSort){
            promiseObject.promise = promiseObject.promise.then(res => (res || []).sort(Sorters.STRING("name")));
        }
        return promiseObject;
    },
    getAllSavedFilterV2(filterType, params, skipSort) {
        const promiseObject = makeCancellableAPIRequest(
            "GET",
            `/api/v2/saved-search/${filterType}`,
            { params }
        );
        if(!skipSort){
            promiseObject.promise = promiseObject.promise.then(res => (res?.data || []).sort(Sorters.STRING("name")));
        } else {
            promiseObject.promise = promiseObject.promise.then(res => (res?.data || []));
        }
        return promiseObject;
    },
    updateLastSavedFilter(id) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/savedSearch/${id}/lastUsed`
        )
    },
    getAllFindingsSavedFilter(params) {
        return SavedSearchAPI.getAllSavedFilter("findings", params);
    },
    getAllFindingsSavedFilterV2(params) {
        return SavedSearchAPI.getAllSavedFilterV2("findings", params);
    },
    getSingleSavedFilter(id) {
        return makeCancellableAPIRequest (
            "GET",
            `/api/savedSearch?id=${id}`
        )
    },
    getSingleSavedFilterV2(id) {
        const promiseObject = makeCancellableAPIRequest (
            "GET",
            `/api/v2/saved-search?id=${id}`
        )
        promiseObject.promise = promiseObject.promise.then((response) => {
            const modifiedResponse = response.data ? {
                data: {
                    ...response.data,
                    cron: reverseModifyCronData(response.data.cronExpressions, response.data.cron)
                }
            } : undefined;
            return modifiedResponse;
        })
        return promiseObject;
    },
    saveSearchFilter(data, filterType) {
        return makeCancellableAPIRequest(
            'POST',
            `/api/savedSearch/${filterType}`,
            {
                data
            }
        )
    },
    saveSearchFilterV2(data, filterType) {
        return makeCancellableAPIRequest(
            'POST',
            `/api/v2/saved-search/${filterType}`,
            {
                data
            }
        )
    },
    updateSearchFilter(id, data) {
        return makeCancellableAPIRequest(
            'PUT',
            `/api/savedSearch/${id}`,
            {
                data
            }
        )
    },
    updateSearchFilterV2(id, data) {
        const modifiedData = modifyCronData(data);
        return makeCancellableAPIRequest(
            'PUT',
            `/api/v2/saved-search/${id}`,
            {
                data: modifiedData
            }
        )
    },
    deleteSearchFilter(id) {
        return makeCancellableAPIRequest(
            'DELETE',
            `/api/savedSearch/${id}`,
        )
    },
    publishSavedSearchToBU(data){
        return makeCancellableAPIRequest(
            'POST',
            `/api/savedSearch/copy`,
            {
                data
            }
        )
    },
    updateShareUsers(id, data){
        return makeCancellableAPIRequest(
            'PUT',
            `/api/savedSearch/${id}/share/users`,
            {
                data
            }
        )
    },
    updateSequence(data){
        return makeCancellableAPIRequest(
            'PUT',
            `/api/savedSearch/update-sequence`,
            {
                data
            }
        )
    },
    getApplicableWidgets(id){
        return makeCancellableAPIRequest(
            'GET',
            `/api/saved-search/${id}/custom-dashboard`
        )
    }
};

export default SavedSearchAPI;